import { combineReducers } from 'redux'
import auth from './authReducer'
import alert from './alertReducer'
import theme from './themeReducer'
import profile from './profileReducer'
import status from './statusReducer'
import homePosts from './postReducer'
import modal from './modalReducer'
import detailPost from './detailPostReducer'
import discover from './discoverReducer'
import suggestions from './suggestionsReducer'
import socket from './socketReducer'
import notify from './notifyReducer'
import message from './messageReducer'
import online from './onlineReducer'
import call from './callReducer'
import page from './PageReducer'
import peer from './peerReducer'
import poll from './pollReducer'
import challenge from './challengeReducer'
import search from './SearchReducer'
import uploadMedia from './uploadMediaReducer'
import loginRegister from './loginRegisterReducer';
import rocketStyleReducer from './rocketStyleReducer'


export default combineReducers({
    auth,
    alert,
    theme,
    profile,
    status,
    homePosts,
    modal,
    search,
    detailPost,
    discover,
    suggestions,
    socket,
    notify,
    message,
    online,
    call,
    peer,
    poll,
    loginRegister,
    challenge,page,
    uploadMedia,
    rocket: rocketStyleReducer,

})